@if (!isLoading) {
  <div class="main-container">
    <div class="header" data-cy="perio-depth-summary-header">General Summary</div>
    <i class="material-icons exit-button" (click)="close()" data-cy="perio-depth-summary-close-button">close</i>
    @for (summarySection of summarySections; track summarySection; let i = $index) {
      <div class="summary-section"
        [class.padding-left]="summarySection.paddingLeft"
        [class.border-right]="summarySection.borderRight"
        [class.inline-summary]="summarySection.small"
        >
        <div class="section-header" data-cy="perio-depth-summary-section-header-{{i}}">{{ summarySection.name }}</div>
        <div class="section-table">
          <div class="table-headers">
            @for (header of summarySection.headers; track header; let j = $index) {
              <div class="table-header"
                [class.no-right-border]="j === summarySection.headers.length-1"
                data-cy="perio-depth-summary-table-header-{{i}}-{{j}}">
                {{ header.name }}
              </div>
            }
          </div>
          @for (section of summarySection.sections; track section; let k = $index) {
            <div class="table-secion">
              <div class="section-value" data-cy="perio-depth-summary-section-name-{{i}}-{{k}}">
                {{ section.name }}
              </div>
              @for (sectionValue of section.values; track sectionValue; let j = $index) {
                <div class="section-value"
                  [class.no-right-border]="j === section.values.length-1"
                  data-cy="perio-depth-summary-section-value-{{i}}-{{k}}-{{j}}">
                  {{ sectionValue }}
                </div>
              }
            </div>
          }
        </div>
      </div>
    }
  </div>
}
@if (isLoading) {
  <div class="spinner-container" data-cy="perio-depth-summary-spinner">
    <mat-spinner></mat-spinner>
  </div>
}
